import { chainConfig, monadFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { monad as viemMonadBase } from 'viem/chains'

import type { AppChain } from './chain.types'

export const monad = viemDefineChain({
  ...viemMonadBase,
  ...chainConfig,
  nativeCurrency: {
    name: 'Monad',
    symbol: 'MON',
    decimals: 18
  },
  contracts: {
    ...viemMonadBase.contracts,
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 0
    }
  }
}).extend({
  viemDlc: monadFacts,
  custom: {
    name: 'Monad',
    shortName: 'Monad',
    safeShortName: 'monad',
    morphoChainSlug: 'monad',
    defiLlamaSlug: 'monad',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://monadscan.com/', name: 'Explorer' },
    simplePermitTokens: ['0x754704Bc059F8C67012fEd69BC8A327a5aafb603'], // USDC
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x09475a3D6eA8c314c592b1a3799bDE044E2F400F',
          startBlock: 31907457n
        },
        MorphoBlue: {
          address: '0xD5D960E8C380B724a48AC59E2DfF1b2CB4a1eAee',
          startBlock: 31907457n
        },
        MetaMorphoV11Factory: {
          address: '0x33f20973275B2F574488b18929cd7DCBf1AbF275',
          startBlock: 32320327n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x8B2F922162FBb60A6a072cC784A2E4168fB0bb0c',
          startBlock: 32321811n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x8Da54fbF89B3D6fC6DCC92F31CF75a211ACF3d46',
          startBlock: 32321811n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xa00666E86C7e2FA8d2c78d9481E687e098340180',
          startBlock: 41103883n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0x9f3c0999425656fD189C69a8aD68cB64986D644A',
          startBlock: 32321811n
        },
        RegistryList: {
          address: '0x6a42f8b46224baA4DbBBc2F860F4675eeA7bd52B',
          startBlock: 32322465n
        },
        BluePublicAllocator: {
          address: '0x0A503aB026EFACBC0F7feE7795F34B80b5B9a662',
          startBlock: 96602489n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
